module.exports = __webpack_public_path__ + "Roboto-Bold.dc81817def276b4f2139.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/~/angular-bootstrap-md/font/roboto/Roboto-Bold.woff
// module id = ../../../../angular-bootstrap-md/font/roboto/Roboto-Bold.woff
// module chunks = 3